"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _rowConfig = _interopRequireDefault(require("../../../../../core/row-config"));
var _formGroup = _interopRequireDefault(require("../../../../../core/form-group"));
var _label = _interopRequireDefault(require("../../../../../core/label"));
var _col = _interopRequireDefault(require("../../../../../core/col"));
var _input = _interopRequireDefault(require("../../../../../core/input"));
var _inputOnBlur = _interopRequireDefault(require("../../../../../core/input-on-blur"));
var _row = _interopRequireDefault(require("../../../../../core/row"));
var _existingUserCheck = _interopRequireDefault(require("../../../../../core/existing-user-check"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// NOTE Also used by New Application Process
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to change ownership");
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "New Owner Name");
var _ref3 = /*#__PURE__*/_react.default.createElement(_label.default, null, "New Owner Email");
var _ref4 = /*#__PURE__*/_react.default.createElement(_col.default, null);
class SetApplicationOwner extends _react.Component {
  render() {
    const application = this.props.application;
    if (!application) return null;
    if (!this.props.userIsCalendarOfficer) return _ref;
    return /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 4
      }, {
        sm: 8
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "string",
      value: application.contactName,
      onChange: this.props.setValue,
      name: "contactName",
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref3, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Email",
      value: application.contactEmail,
      onChange: this.props.setValue,
      name: "contactEmail",
      required: true
    }))), /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref4, /*#__PURE__*/_react.default.createElement(_col.default, null, !application.contactEmail ? null : /*#__PURE__*/_react.default.createElement(_existingUserCheck.default, {
      userEmail: application.contactEmail
    })))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = SetApplicationOwner;